var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"text-center pt-3 mt-3 font-weight-bold"},[_c('p',{},[_vm._v("الحقوق محفوظة للشركة "),_c('span',{staticClass:"blue--text"},[_vm._v("الهندسية")]),_vm._v(" © "+_vm._s(_vm.currentYear)+".")])])
}
var staticRenderFns = []

export { render, staticRenderFns }